<template>
  <div class="header">
    <div class="pagew header-box">
      <!-- logo区域 -->
      <div class="logo_content">
        <img src="@/assets/other/logoph.jpg" alt="公司logo" class="logo-img" />
      </div>
      <!-- 顶部导航菜单区域 -->
      <div class="nav-list">
        <router-link class="nav-btn home-btn" to="/homepage"
          >&nbsp&nbsp&nbsp首页&nbsp&nbsp&nbsp</router-link
        >
        <router-link class="nav-btn" to="/Work/list">全球化IT服务</router-link>
        <router-link class="nav-btn" to="/cooperation">典型案例</router-link>
        <router-link class="nav-btn" to="/solution">解决方案</router-link>
        <router-link class="nav-btn" to="/workspace">关于我们</router-link>
      </div>
      <!-- 语言下拉选择框 -->
      <select id="language">
        <option value="zh">中文</option>
        <option value="en">English</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: String,
      default: "/homepage",
    },
  },
  data() {
    return {
      // activeIndex: "/homepage",
      showQr: false,
      selectedLanguage: "中文",
    };
  },
  methods: {
    onShowQrCode() {
      this.showQr = true;
    },
    onHide() {
      this.showQr = false;
    },
    handleSelect(key, keyPath) {
      this.$router.push(key);
    },
    goLogin() {
      window.location.href = "http://8.134.120.63/";
    },
    goregister() {
      window.location.href = "http://8.134.120.63/register";
    },
    changeLanguage(language) {
      this.selectedLanguage = language;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  // box-shadow: 0 5px 10px rgba(255, 0, 0, 0.1);
}

#language {
  appearance: none; /* 移除默认样式 */
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: rgba(255, 255, 255, 0.1); /* 半透明背景 */
  border: 1px solid #fff; /* 白色边框 */
  border-radius: 4px; /* 圆角 */
  color: #fff; /* 文字颜色 */
  font-size: 16px;
  padding: 8px 30px 8px 12px; /* 内边距 */
  cursor: pointer;
  transition: all 0.3s ease; /* 过渡效果 */
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='7' viewBox='0 0 12 7'%3E%3Cpath fill='%23FFFFFF' d='M1 1l5 5 5-5'/%3E%3C/svg%3E"); /* 自定义下拉箭头 */
  background-repeat: no-repeat;
  background-position: right 10px center;
}

#language:hover {
  background-color: rgba(255, 255, 255, 0.2); /* 悬停时背景变深 */
}

#language:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5); /* 聚焦时的阴影效果 */
}

#language option {
  background-color: #5097d5; /* 选项背景颜色 */
  color: #fff; /* 选项文字颜色 */
}

.qr-img {
  position: absolute;
  right: 100px;
  top: 40px;
  width: 120px;
  left: -30px;
}

.qr-img::before {
  content: "";
  width: 0;
  height: 0;
  border-width: 10px;
  border-color: transparent transparent #fff;
  border-style: solid;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -18px;
}

.login {
  background-color: transparent;
  border: 1px solid #5097d5;
  width: 90px;
  height: 40px;
  color: #5097d5;
}

.regiest {
  width: 100px;
  height: 40px;
  background-color: #5097d5;
  color: #ffffff;
}

.el-menu {
  background-color: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.header {
  background-color: transparent !important;
  position: absolute;
  /* 改为绝对定位，悬浮在背景图上 */
  top: 0;
  width: 100%;
  z-index: 100;
  // padding: 1vh 0;

  .logo_content {
    position: relative;
    z-index: 1000;
    // margin-left: 0; // 确保左侧没有额外间距
    // padding-left: 0; // 确保左侧没有额外内边距
    // padding-right: -60px;
  }

  .logo_content img {
    width: 217px; // 固定宽度或使用百分比
    height: 58px;
    object-fit: contain;
    // display: block;
  }
}

.header-box {
  display: flex;
  // height: 100%;
  justify-content: space-between;
  padding-left: -100px;
  /* 增加左侧内边距 */
  align-items: center;
}

.nav-list {
  display: flex;
  gap: 0 30px;
  /* 字段之间的间距统一为30px */
  font-size: 0;
  position: relative;
  width: 100%;
  padding-left: 22%;
}

.nav-btn {
  position: relative;
  padding: 0 10px;
  line-height: 82px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  display: inline-block;

  /* 下划线伪元素 */
  &::after {
    content: "";
    position: absolute;
    bottom: 20px;
    left: 10px;
    width: calc(100% - 20px);
    height: 2px;
    background: #ffffff;
    transform: scaleX(0);
    /* 初始状态：完全透明 */
    transform-origin: left center;
    /* 从左侧开始缩放 */
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    /* 饿了么同款缓动曲线 */
  }

  /* 激活状态：下划线完全显示 */
  &.router-link-active::after {
    transform: scaleX(1);
    /* 从左侧展开到100% */
  }

  // /* 悬停效果（可选） */
  // &:hover::after {
  //   transform: scaleX(1);
  // }
}

.help-btn {
  position: relative;

  a {
    width: 60px;
  }
}
</style>
<style lang="scss">
.nav-list .nav-btn:hover,
.nav-btn.router-link-active {
  transition: all 1s;
  // background: url("../../assets/image/nav_bg.png") center bottom #5097d5;
  color: #fff;
}

.el-menu-demo .nav-btn:hover {
  transition: all 1s;
  // background: url("../../assets/image/nav_bg.png") center bottom #5097d5;
  color: #fff;
}

.select-div ul li {
  cursor: pointer;
  list-style: none;
  line-height: 60px;
  width: 120px;

  a {
    padding: 8px 5px;
    font-size: 14px;
    font-weight: 550;
  }
}

.select-div ul li:hover {
  transition: all 1s;
  background: #5097d5;

  a {
    color: #fff;
  }
}

.select-cooperation-div {
  background-color: rgba($color: #fff, $alpha: 0.65);
  position: absolute;
  top: 82px;
  left: 805px;
  display: none;
}

.select-about-div {
  background-color: rgba($color: #fff, $alpha: 0.65);
  position: absolute;
  top: 82px;
  left: 882px;
  display: none;
}

.setactive:hover {
  transition: all 1s;

  .select-div {
    transition: all 1s;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue